module.exports = __webpack_public_path__ + "static/media/om_hairstyle_buzz_front_shadow.bb6c4c45.png";